/* --------------------------------
[JSファイルの説明]
・gulpで scripts.json の libs の各ファイルを連結し、 /js/libs.js に書き出している
・gulpで scripts.json の scripts の各ファイルを連結＆圧縮し、 /js/scripts.js に書き出している
・HTMLでは上記の libs.js と scripts.js を読み込んでいる
・もしもgulpの環境が無くて更新が困難な場合は、書き出したJSは無視して scripts.json の各ファイルをHTMLで直接読み込んでも動作は可能
-------------------------------- */

// スクロールバーを除いたウィンドウ幅をCSSのカスタムプロパティに設定
const setVw = function () {
  const vw = document.documentElement.clientWidth;
  document.documentElement.style.setProperty('--vw', `${vw}px`);
}
window.addEventListener('DOMContentLoaded', setVw);
window.addEventListener('resize', setVw);

//aタグ スムーススクロール
$(function () {
  $('a[href^="#"]').click(function () {
    var speed = 500;
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({ scrollTop: position }, speed, "swing");

    $('.p-hd__menu button, .p-gnav').removeClass('is-on');

    return false;
  });
});

//スライダー
$(function () {
  $('.home-kv__slick').each(function (index, el) {
    const $slider = $(this);

    $slider.slick({
      autoplay: true,
      autoplaySpeed: 3000,
      fade: true,
      speed: 1000,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
      arrows: false,
      dots: false
    });
  });
});

//フェード
$(function () {
  var fade = $('.u-fade, .js-fadeAni');

  fade.each(function (index, el) {
    var t = $(this);

    setTimeout(function () {
      $(window).on('resize scroll', function (event) {
        run();
      });

      run();
    }, 200);

    function run() {
      var winT = $(window).scrollTop();
      var winH = $(window).innerHeight();
      var winB = winT + winH;
      var tT = t.offset().top;
      var tH = t.innerHeight();
      var tB = tT + tH;

      var pointH = tT + 50;
      var pointSc = winB;
      var pointD = 200;

      var h = t.attr('data-fade-h');
      if (h) {
        pointH = tT + tH * h / 100;
      }

      var sc = t.attr('data-fade-sc');
      if (sc) {
        pointSc = winT + winH * sc / 100;
      }

      var d = t.attr('data-fade-delay');
      if (d) {
        pointD = d;
      }

      if (pointH < pointSc) {
        setTimeout(function () {
          t.addClass('is-fade');
          next();
        }, pointD);
      }
    }

    function next() {
      var nextStr = t.attr('data-fade-next-target');
      if (nextStr) {
        var nextArr = nextStr.split(' ');
        if (nextArr) {
          for (var i = 0; i < nextArr.length; i++) {
            var next = nextArr[i];
            var nextTar = $('[data-fade-next-id="' + next + '"]');
            if (nextTar[0]) {
              var nextDelay = t.attr('data-fade-next-delay');
              var delay = 200;
              if (nextDelay) {
                delay = parseInt(nextDelay);
              }

              var nextStep = t.attr('data-fade-next-step');
              var step = 200;
              if (nextDelay) {
                step = delay;
              }
              if (nextStep) {
                step = parseInt(nextStep);
              }

              nextTar.each(function (index, el) {
                var t2 = $(this);
                var step2 = step * index + delay;

                setTimeout(function () {
                  t2.addClass('is-fadeNext');
                  t2.attr('data-test', step2);
                }, step2);
              });
            }
          }
        }
      }
    }
  });
});

$(function(){
  $('.p-hd__menu button').each(function (index, element) {
    const $btn = $(this);
    const $nav = $('.p-gnav');

    $btn.attr('aria-expanded', 'false');
    $nav.attr('aria-hidden', 'true');

    $btn.on('click', function () {
      $btn.toggleClass('is-on');
      $nav.toggleClass('is-on');
      const isOpen = $btn.hasClass('is-on');
      $btn.attr('aria-expanded', isOpen ? 'true' : 'false');
      $nav.attr('aria-hidden', isOpen ? 'false' : 'true');
    });
  });
});

$(function(){
  $('.doc-page').each(function (index, element) {
    const $root = $(this);
    const $btn = $root.find('.doc-ttl');
    const $con = $root.find('.doc-con');

    $btn.attr('aria-expanded', 'false');
    $con.attr('aria-hidden', 'true');

    $btn.on('click', function () {
      $root.toggleClass('is-on');
      $btn.toggleClass('is-on');
      const isOpen = $btn.hasClass('is-on');
      $btn.attr('aria-expanded', isOpen ? 'true' : 'false');
      $con.attr('aria-hidden', isOpen ? 'false' : 'true');
      $con.stop().slideToggle(300);
    });
  });

});
  
function openDocCon() {
  const hash = window.location.hash;
  if (hash && $(hash).length) {
    const $tar = $(hash).find('.doc-page');
    const $tarBtn = $tar.find('.doc-ttl');
    const $tarCon = $tar.find('.doc-con');

    $tar.addClass('is-on');
    $tarBtn.addClass('is-on');
    $tarCon.stop().slideDown(300);
  }
}
$(window).on('pageshow', function(event) {
  openDocCon();
  setTimeout(function(){ openDocCon(); }, 100);
  setTimeout(function(){ openDocCon(); }, 200);
});

$(function(){
  $('.home-procedure__btns button, .service-btns__btns button').each(function (index, element) {
    const $btn = $(this);
    const $con = $btn.next();

    $btn.on('click', function () {
      $btn.toggleClass('is-on');
      $con.stop().slideToggle(300);
    });
  });
});



let scDataDate = [];

function initScSearch() {
  const $itemArea = $('.support-scItemArea');
  const $item = $('.support-scItem');
  const $blank = $('.support-sche__blank');
  const $searchBtn = $('.support-scSearch__searchBtn');
  const $searchBtn2 = $('.support-scSearch__searchBtn2');
  const $area = $('select[name="area"]');
  const $dateM = $('select[name="m"]');
  const $dateMOp = $dateM.find('option');
  const $dateD = $('select[name="d"]');
  const $dateDOp = $dateD.find('option');
  const $total = $('.support-sche__mapTotal span');

  $searchBtn.on('click', function(event) {
    run();
  });

  $searchBtn2.on('click', function(event) {
    $dateM.val('');
    $dateD.val('');
    run();
  });

  $dateM.on('change', function(event) {
    setDate();
  });

  $dateD.on('change', function(event) {
//    $dateDOp.eq(0).text('日');
  });

  //不要な月を非表示
  const hideMList = [...new Set(scDataDate.map(item => item.split('/')[0]))];
  $dateMOp.each(function(index, el) {
    if(index > 0) {
      const $t = $(this);

      let dateM = $t.val();

      if(hideMList.indexOf(dateM) != -1) {
        $t.show();
      } else {
        $t.hide();
      }
    }
  });

  setDate();

  function setDate() {
    let md = '';

    $dateDOp.each(function(index, el) {
      if(index > 0) {
        const $t = $(this);

        let dateM = $dateM.val();
        let dateD = $t.val();
        let dateMD = dateM + '/' + dateD;

        if(scDataDate.indexOf(dateMD) != -1) {
          $t.show();
        } else {
          $t.hide();
        }
      }
    });
  }

  function run() {
    //エリア絞り込み
    $itemArea.hide();
    $item.hide();
    $item.show();

    let area = $area.val();

    if(area) {
      $item.each(function(index, el) {
        const $t = $(this);

        if($t.css('display') != 'none') {
          const tArea = $t.attr('data-area');

          let isHit = false;

          if(tArea == area) {
            isHit = true;
          }

          if(!isHit) {
            $t.hide();
          }
        }
      });
    }

    //日付絞り込み
    //let dateM = ( '00' + $dateM.val() ).slice( -2 );;
    //let dateD = ( '00' + $dateD.val() ).slice( -2 );;
    let dateM = $dateM.val();
    let dateD = $dateD.val();
    let dateMD = dateM + '/' + dateD;

    if(dateM && dateD) {
      $item.each(function(index, el) {
        const $t = $(this);

        if($t.css('display') != 'none') {
          const tDate = $t.attr('data-date');
          const arr = tDate.split('_');

          let isHit = false;

          for (var i = 0; i < arr.length; i++) {
            if(arr[i] == dateMD) {
              isHit = true;
            }
          }

          if(!isHit) {
            $t.hide();
          }
        }
      });
    }

/*    if(dateD) {
      $dateDOp.eq(0).text('日（全ての日）');
    } else {
    }*/

    //エリアタイトル表示
    $itemArea.each(function(index, el) {
      const $t = $(this);
      let tArea = $t.attr('data-area');
      let $tItem = $item.filter('[data-area="' + tArea + '"]');

      $tItem.each(function(index, el) {
        if($(this).css('display') != 'none') {
          $t.stop().fadeIn(800);
          return false;
        }
      });
    });

    //総数チェック
    let total = 0;

    $item.each(function(index, el) {
      if($(this).css('display') != 'none') {
        total ++;
      }
    });
    
    $total.text(total);

    if(total == 0) {
      $blank.hide();
      $blank.stop().fadeIn(800);
    } else {
      $blank.hide();
    }

    //スクロール
    var target = $('#sccon');
    var position = target.offset().top - 50;
    $("html, body").animate({scrollTop:position}, 400, "swing");
  }
}

$(function() {
  const $tar = $('.js-loadSc');

  $tar.each(function(index, el) {
    const $t = $(this);
    let label1 = $t.attr('data-label1');
    let label2 = $t.attr('data-label2');
    let label3 = $t.attr('data-label3');

    label2 = label2.replaceAll(',', '<br>');

    function parseCsv(data) {
      var csv = $.csv.toArrays(data);

      var insert = '';

      let nowArea = '';
      let oldArea = '';
      let num = 0;
      let total = 0;
      let oddEven = '';

      $(csv).each(function(i) {
        
        if (this.length > 0) {
          var i2 = -1;
          var arr = ['', '', '', '', '', '', '', '', '', '', '', '', ''];

          $(this).each(function() {
            i2 ++;
            arr[i2] = this;
          });

          if(arr[9]) {
            console.log('NO');
          }
            

          oldArea = nowArea;
          nowArea = arr[0];

          total ++;

          // エリアタイトル
          // if(nowArea != oldArea) {
          //   num = 0;
          //   insert += '<p class="support-scItemArea" data-area="' + arr[0] + '">' + arr[0] + '</p>';
          // }

/*          num ++;
          if(num % 2) {
            oddEven = 'odd';
            if(nowArea == oldArea) {
              insert += '<hr class="support-scItemLine" />';
            }
          } else {
            oddEven = 'even';
          }*/


          insert += '<div class="support-scItem -n' + num + '" data-area="' + nowArea + '" data-date="' + arr[6] + '" data-state="' + arr[9] + '">';
          insert += '  <div class="support-scItem__ttl">';
          insert += '      <p class="support-scItem__txt0">' + arr[0] + '</p>';
          insert += '      <p class="support-scItem__txt1">' + arr[1] + '</p>';
          insert += '      <p class="support-scItem__txt2">' + arr[2] + '</p>';
          insert += '      <p class="support-scItem__txt3">' + arr[3] + '</p>';
          if(arr[7]) {
            insert += '      <p class="c-mapBtn"><a href="' + arr[7] + '"target="_blank" rel="noopener">' + label3 + '</a></p>';
          }
          insert += '  </div>';
          insert += '  <div class="support-scItem__rows">';
          insert += '  <div class="support-scItem__row">';
          insert += '    <p class="support-scItem__label">' + label1 + '</p>';
          insert += '    <div class="support-scItem__info">';
          insert += '      <p class="support-scItem__txt4">' + arr[4] + '</p>';
          insert += '    </div>';
          insert += '  </div>';
          insert += '  <div class="support-scItem__row">';
          insert += '    <p class="support-scItem__label">' + label2 + '</p>';
          insert += '    <div class="support-scItem__info">';
          insert += '      <p class="support-scItem__txt5">' + arr[5] + '</p>';
          insert += '    </div>';
          insert += '  </div>';
          insert += '  </div>';
          
          if(arr[8]) {
          insert += '  <div class="support-scItem__memo">';
          insert += '    <p class="support-scItem__txt5">' + arr[8] + '</p>';
          insert += '  </div>';
          }

          insert += '  <div class="support-scItem__btns"><ul>';
          if(arr[11] == 2 || arr[11] == 3) {
            insert += '    <li class="-n1"><a href="' + $t.attr('data-btn-url1') + arr[10] + $t.attr('data-btn-url2') + $t.attr('data-btn1-course') + '" target="_blank" rel="noopener"><i></i><span>' + $t.attr('data-btn1') + '</span></a></li>';
            insert += '    <li class="-n2"><a href="' + $t.attr('data-btn-url1') + arr[10] + $t.attr('data-btn-url2') + $t.attr('data-btn2-course') + '" target="_blank" rel="noopener"><i></i><span>' + $t.attr('data-btn2') + '</span></a></li>';
            insert += '    <li class="-n3"><a href="' + $t.attr('data-btn-url1') + arr[10] + $t.attr('data-btn-url2') + $t.attr('data-btn3-course') + '" target="_blank" rel="noopener"><i></i><span>' + $t.attr('data-btn3') + '<small>' + $t.attr('data-btn3-2') + '</small></span></a></li>';
            insert += '    <li class="-n4"><a href="' + $t.attr('data-btn-url1') + arr[10] + $t.attr('data-btn-url2') + $t.attr('data-btn4-course') + '" target="_blank" rel="noopener"><i></i><span>' + $t.attr('data-btn4') + '<small>' + $t.attr('data-btn4-2') + '</small></span></a></li>';
            insert += '    <li class="-n5"><a href="' + $t.attr('data-btn-url1') + arr[10] + $t.attr('data-btn-url2') + $t.attr('data-btn5-course') + '" target="_blank" rel="noopener"><i></i><span>' + $t.attr('data-btn5') + '</span></a></li>';
          }
          if(arr[11] == 1 || arr[11] == 2) {
            insert += '    <li class="-n6"><a href="' + $t.attr('data-btn6-url') + '" target="_blank" rel="noopener"><i></i><span>' + $t.attr('data-btn6') + '<small>' + $t.attr('data-btn6-2') + '</small></span></a></li>';
          }
          insert += '  </ul></div>';
          
          // if(arr[8]) {
          //   insert += '      <p class="support-scItem__txt6">' + arr[8] + '</p>';
          // }
          // if(arr[10] == '1') {
          //   insert += '      <a class="support-scItem__modalBtn -n1 u-over" href="javascript:void(0);" data-remodal-target="scItemModal1"></a>';
          // }
          // if(arr[10] == '2') {
          //   insert += '      <a class="support-scItem__modalBtn -n2 u-over" href="javascript:void(0);" data-remodal-target="scItemModal2"></a>';
          // }
          insert += '</div>';
        }

        $t.append(insert);
        insert = "";

        //日付保存
        let arr2 = arr[6].split('_');

        for (var i = 0; i < arr2.length; i++) {
          scDataDate.push(arr2[i]);
        }
      });

      $('.support-sche__mapTotal span').text(total);

      initScSearch();
    }

    let path = $t.attr('data-path');
    $.ajaxSetup({
      beforeSend : function(xhr) {
//        xhr.overrideMimeType('text/html;charset=Shift_JIS');
      }
    });
    $.get(path, parseCsv, 'text');
  });
});

